import { isNil } from "ramda";

import { deleteUser, getAllUsersData } from "../../../api";
import { verifyRequestError } from "../../../utils/utils";

export const loadUsers = async (setUsers, setLoading, dispatch, navigate, intl) => {
  setLoading(true);
  try {
    const response = await getAllUsersData();
    if (!isNil(response?.status) && response?.status === 200 && !isNil(response.data)) {
      await setUsers(response.data.data);
    }
  } catch (error) {
    verifyRequestError({ error, dispatch, navigate, intl });
  }
  setLoading(false);
};

export const getColumns = (intl) => {
  const columns = [
    { field: "id", headerName: "Id", width: 180, hide: true },
    { field: "avatar", headerName: "", flex: 0.2 },
    { field: "name", headerName: intl.formatMessage({ id: "name" }), flex: 0.8 },
    { field: "username", headerName: intl.formatMessage({ id: "email" }), flex: 1 },
    { field: "role", headerName: intl.formatMessage({ id: "role" }), flex: 0.5 },
    { field: "measurementAlerts", headerName: intl.formatMessage({ id: "measurement.alerts" }), flex: 0.6 },
    { field: "equipmentAlerts", headerName: intl.formatMessage({ id: "equipment.alerts" }), flex: 0.6 },
    { field: "demarcations", headerName: intl.formatMessage({ id: "demarcations" }), flex: 1 },
    { field: "organization", headerName: intl.formatMessage({ id: "organization" }), flex: 0.5 },
    {
      field: "actions",
      type: "actions",
      headerName: intl.formatMessage({ id: "actions" }),
      flex: 0.8,
      cellClassName: "actions",
      getActions: null,
    },
  ];
  return columns;
};

export const handleDeleteUser = async ({ id, setUsers, setLoading, setOpenTextModal, dispatch, navigate, intl }) => {
  if (isNil(id)) {
    return;
  }
  try {
    const response = await deleteUser(id, intl);
    if (!isNil(response)) {
      loadUsers(setUsers, setLoading, dispatch, navigate);
      setOpenTextModal(false);
    }
  } catch (error) {
    verifyRequestError({ error, dispatch, navigate, intl });
  }
};
